<template>
	<div class="app-container">
		<el-container class="bg">
			<!-- 侧栏宽度随折叠状态变化：collapsed 由 leftMenu 暴露 -->
			<el-aside class="left_bg" :class="{ 'is-collapsed': sideCollapsed }" :width="sideWidth">
				<leftMenuDiv ref="leftMenuDiv"></leftMenuDiv>
			</el-aside>
			<el-main class="content-box">
				<router-view></router-view>
			</el-main>
		</el-container>
		<div v-if="username" class="watermark">
			<span v-for="n in 80" :key="n" :style="getWatermarkStyle(n)">{{ username }}{{ deptName ? "【" + deptName + "】" : "" }}</span>
		</div>
	</div>
</template>

<script>
import { leaveOnlineSession } from "@/utils/onlinePresence";
import { GetAttachmentPath } from "@/api/systemApi.js";
import leftMenuDiv from "./mainIndex/leftMenu.vue";

const STORAGE_KEY = "lcsj-menu-collapsed";

export default {
	data() {
		return {
			userInfo: {},
			roleInfo: {},
			loading: false,
			username: "",
			deptName: "",
			sideCollapsed: readStore()
		};
	},
	computed: {
		/** 侧栏宽度：折叠 64px / 展开 260px，与 leftMenu 内部保持一致 */
		sideWidth() {
			return this.sideCollapsed ? "64px" : "260px";
		}
	},
	components: {
		leftMenuDiv
	},
	mounted() {
		this.getFileInfoPathData();
		this.userInfo = JSON.parse(localStorage.getItem("setUserInfo")) || {};
		let userdata = JSON.parse(localStorage.getItem("userdata"));
		if (userdata && userdata.userInfo) {
			this.username = userdata.userInfo.chName;
			this.deptName = userdata.userInfo.dept || "";
		}
		// 订阅左侧菜单的折叠状态
		if (this.$root.Bus) {
			this.$root.Bus.$on("toggle", (value) => {
				this.sideCollapsed = !!value;
			});
		}
	},
	methods: {
		// 获取附件前缀
		getFileInfoPathData() {
			GetAttachmentPath()
				.then((res) => {
					if (res.code === 1) {
						localStorage.setItem("filePath", res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
				});
		},

		// 退出登录
		clickLoginout() {
			this.$confirm("退出登录, 是否继续?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				setTimeout(async () => {
					if (this.$tabs) {
						this.$tabs.reset();
					}
					await leaveOnlineSession();
					localStorage.clear();
					this.$router.replace({
						path: "/login"
					});
					this.$message({
						type: "success",
						message: "已退出登录!"
					});
				}, 300);
			});
		},

		// 水印位置计算
		getWatermarkStyle(index) {
			const col = (index - 1) % 8;
			const row = Math.floor((index - 1) / 8);
			const top = 80 + row * 180;
			const left = 80 + col * 250;
			return {
				top: top + "px",
				left: left + "px"
			};
		}
	}
};

/* 折叠状态与leftMenu / lcsjMenuToggle 共用同一 key */
function readStore() {
	try {
		return window.localStorage.getItem(STORAGE_KEY) === "1";
	} catch (e) {
		return false;
	}
}
</script>

<style>
html,
body {
	margin: 0;
	padding: 0;
	overflow: hidden;
}
</style>

<style scoped lang="scss">
html,
body {
	width: 100%;
	height: 100%;
}

/* ⚠ 此处原来写 calc(100vh - 3.5rem)：项目 pxtorem rootValue=16 ⇒ 1rem=16px，
   3.5rem 实际只有 56px，而顶部栏 navcon 是 60px —— 差4px 导致内容区与侧栏
   比顶部栏矮一截、底部露出滚动条。统一改为 token 避免再次漂移。 */
.bg {
	width: 100%;
	background: var(--app-surface);
	height: calc(100vh - var(--app-topbar-height));
	overflow: auto;
}

.app-container {
	position: relative;
	width: 100%;
	height: 100%;
}

/*
 * 侧栏容器：宽度由 el-aside 的 :width 绑定控制（折叠 64 / 展开 260）。
 * 此前写死 `width:260px !important`，导致 leftMenu 的 :collapse
 * 视觉上折叠了但容器不变宽 —— 折叠功能形同失效。
 */
.left_bg {
	background: var(--app-sidebar-bg);
	height: calc(100vh - var(--app-topbar-height));
	border: 0 solid transparent;
	display: flex;
	flex-direction: column;
	align-items: stretch;
	overflow: visible;
	transition: width 0.25s ease;
	flex-shrink: 0;
}

/* 内容区：用 1px 细边线分隔即可，原来的 4px 边框过重。
   ⚠ overflow 必须保持 hidden —— 各列表页的 STable 依赖它做内部滚动、
     自身用固定 height；若改成 auto 会让整页滚动、表格头吸顶失效。 */
.el-card__body,
.el-main {
	padding: 0px !important;
	border: 0;
	border-left: 1px solid var(--app-border-light);
	overflow: hidden;
	background: var(--app-page-bg);
}

.watermark {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	pointer-events: none;
	z-index: 9999;
	overflow: hidden;
}

.watermark span {
	position: absolute;
	top: 150px;
	left: 150px;
	font-size: 18px;
	color: rgba(0, 0, 0, 0.08);
	white-space: nowrap;
	transform: rotate(-45deg);
	transform-origin: left top;
}
</style>
